import { IMSId, IMSObject } from "./ims-object";

export const FUNCTIONGROUP_SYSCODE_PCD = 'PCD';

export class FunctionGroup extends IMSObject {
  static fromDto(dto: FunctionGroupDTO, databag?: any) {
    const obj = new this(
      {
        imsId: dto.id,
        secondaryId: undefined,
        objRef: 'ims/FunctionGroup'
      },
      dto.label,
      dto.name,
      dto.description,
      dto.syscode,
      dto.sortorder
    );

    if (databag) {
      obj.databag = databag
    } else {
      obj.databag = dto;
    }
    return obj;
  }

  constructor(
    public readonly id: IMSId,
    label: string,
    public name: string,
    public description: string,
    public syscode: string = undefined,
    // Order the backend lists its function groups in. Drives the grouping of
    // the PCD entries (see ProjectContactDirectoryFormField.orderEntries()) -
    // the entries' own sortorder only counts within one function group.
    // Absent when the backend is older than this field.
    public sortorder: number = undefined
  ) {
    super(id.imsId, id.secondaryId, label, id.objRef);
  }

  /**
   * What the pickers sort their rows by - see IMSObject.convertToViewModel(),
   * which compares this as a *string*. A function group that carries the
   * backend's sortorder is therefore offered in that order rather than
   * alphabetically, zero-padded so 10 doesn't end up before 2.
   *
   * A sorting explicitly configured via app parameter still wins, and without
   * a sortorder (backend older than the field) it stays at the inherited
   * sorting by label.
   */
  public override get sortingAttribute(): string {
    if (this.labelFormatSettings?.sorting?.attribute || this.sortorder == undefined) {
      return super.sortingAttribute;
    }
    return `${this.sortorder}`.padStart(10, '0');
  }
}

export interface FunctionGroupDTO {
  id: number;
  label: string;
  name: string;
  description: string;
  syscode?: string;
  sortorder?: number;
}
